import { Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { Close, Folder } from '@mui/icons-material';
import React from 'react';

const AntecedentesOrganismo = ({ data, setDatos, errores }) => {
    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                setDatos({ target: { name: 'imagenes', value: [...data.imagenes, imagen] } });
            };
            reader.readAsDataURL(imagen);
        }
    }

    const removeImg = (imgurl) => {
        setDatos({ target: { name: 'imagenes', value: data.imagenes.filter(img => img.dataurl !== imgurl) } });
    }

    const handleSociosOrigenChange = (field, value) => {
        setDatos({
            target: {
                name: 'socios_origen',
                value: {
                    ...data.socios_origen,
                    [field]: value
                }
            }
        });
    };

    return (
        <div>
            <Grid container spacing={2}>
                {/* Sección de fecha, lugar y origen */}
                <Grid item md={6} xs={12}>
                    <Typography variant="h5">Antecedentes del organismo</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Fecha y lugar de las primeras sesiones"
                        value={data.fecha_lugar}
                        onChange={(e) => setDatos({ target: { name: 'fecha_lugar', value: e.target.value } })}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Origen del organismo"
                        value={data.origen}
                        onChange={(e) => setDatos({ target: { name: 'origen', value: e.target.value } })}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        InputProps={{ inputProps: { maxLength: 4 }, maxLength: 4 }}
                        label="Año de inicio"
                        value={data.year_inicio}
                        onChange={(e) => {
                            if (!isNaN(Number(e.target.value))) {
                                setDatos({ target: { name: 'year_inicio', value: e.target.value } });
                            }
                        }
                        }
                    />
                </Grid>

                {/* Sección de imágenes */}
                <Grid item md={6} xs={12}>
                    <Typography variant="h6">Fotogalería de las primeras sesiones*</Typography>
                    <Typography variant="subtitle1">(Máximo 3 fotografías)</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {data.imagenes.map((image) => (
                            <Box key={image.name} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, p: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center' }}>
                                <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(image.dataurl)}>
                                    <Close />
                                </IconButton>
                                <img src={image.dataurl} alt={image.name} width="150px" />
                            </Box>
                        ))}
                    </Box>
                    <Button disabled={data.imagenes.length > 2} component="label" variant="contained" startIcon={<Folder />}>
                        Agregar <input name="imagen" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                    </Button>
                </Grid>

                {/* Sección de socios del origen */}
                <Grid item xs={12}>
                    <Typography variant="h6">Socios del origen</Typography>
                    <Stack direction="row" spacing={2} marginY={2}>
                        <TextField
                            fullWidth
                            label="Cantidad de empresas"
                            type="number"
                            value={data.socios_origen.n_empresas}
                            onChange={(e) => handleSociosOrigenChange('n_empresas', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Cantidad de organizaciones"
                            type="number"
                            value={data.socios_origen.n_organizaciones}
                            onChange={(e) => handleSociosOrigenChange('n_organizaciones', e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Total de socios"
                            type="number"
                            value={data.socios_origen.total_socios}
                            onChange={(e) => handleSociosOrigenChange('total_socios', e.target.value)}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </div>
    )
}

export default AntecedentesOrganismo;
